export default {
  dbi_range_month_picker_launch: 'Launch',
  dbi_range_release_date_picker_launch: 'Release',
  dbi_range_month_picker_please_enter_correct_date: 'Please enter correct date',
  dbi_range_month_picker_over_max_date: 'Date out of range',
  dbi_range_month_picker_over_365_dates: 'Date range should be less than 365 days',
};
